var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardFeatureSelectionOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.5C15.2467 19.5 19.5 15.2467 19.5 10C19.5 4.75329 15.2467 0.5 10 0.5C4.75329 0.5 0.5 4.75329 0.5 10C0.5 15.2467 4.75329 19.5 10 19.5Z",
    stroke: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99956 13.3V6.69898C6.99956 6.44091 7.1719 6.31165 7.246 6.26805C7.32009 6.22445 7.51678 6.13658 7.74238 6.26191L13.6832 9.56239C13.9154 9.69135 13.9404 9.91101 13.9404 9.99947C13.9404 10.0879 13.9154 10.3076 13.6832 10.4366L7.74238 13.737C7.51678 13.8624 7.32009 13.7745 7.246 13.7309C7.1719 13.6873 6.99956 13.558 6.99956 13.3Z",
    fill: "#AECDFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4404 9.99919L7.49956 6.6987L7.49956 13.2997L13.4404 9.9992C13.4404 9.9992 13.4404 9.9992 13.4404 9.99919ZM14.4404 9.99919C14.4404 10.341 14.269 10.6828 13.9261 10.8733L7.9852 14.1738C7.31867 14.5441 6.49956 14.0622 6.49956 13.2997L6.49956 6.6987C6.49956 5.93622 7.31867 5.45425 7.9852 5.82455L13.9261 9.12503C14.269 9.31553 14.4404 9.65736 14.4404 9.99919Z",
    fill: "#AECDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardFeatureSelectionOperationIcon);
export default __webpack_public_path__ + "static/media/ForwardFeatureSelectionOperationIcon.d31d5898c5ef335b40fa44e6dac362dd.svg";
export { ForwardRef as ReactComponent };